import { ReactNode } from 'react';
import { Upload } from 'antd';
import { useTranslation } from 'react-i18next';
import { RcFile, UploadProps } from 'antd/lib/upload';
import { IPOMessage } from '@hylaa-npm/ipod';

import UserAvatarUpload from './UserAvatar';
import { uploadFile } from '@/utils/file';

interface IPUploadProps {
	children: ReactNode;
	handleUploadPre: (data: IFile) => void;
}
type Props = UploadProps & IPUploadProps;

export function PUpload({ children, handleUploadPre, ...uploadProps }: Props) {
	const { t } = useTranslation();
	const beforeUpload: (file: RcFile) => void = async (file: RcFile) => {
		try {
			if (!file) return;
			const data: IFile | boolean = await uploadFile(file);
			if (!data) return false;
			handleUploadPre(data as IFile);
			return false;
		} catch (e) {
			IPOMessage.error(t('common.uploadFail'));
		}
	};

	return (
		<Upload showUploadList={false} beforeUpload={(file) => beforeUpload(file)} {...uploadProps}>
			{children}
		</Upload>
	);
}

export const PUploadFn = {
	User: UserAvatarUpload,
};
